import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  AlertMessage,
  alertApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { Observable as BackstageObservable } from '@backstage/types';
import { Subject } from 'rxjs';

class AppAlertApi {
  private readonly alertsSubject = new Subject<AlertMessage>();

  post(alert: AlertMessage): void {
    this.alertsSubject.next(alert);
  }

  alert$(): BackstageObservable<AlertMessage> {
    return this.alertsSubject.asObservable() as unknown as BackstageObservable<AlertMessage>;
  }
}

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: alertApiRef,
    deps: {},
    factory: () => new AppAlertApi(),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
